var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBb8CarouselArrowActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "48px",
    viewBox: "0 0 14 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7DFD79D2-C821-45CF-A430-D668B2B275FE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visuals",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Billing---Issuer-details",
    transform: "translate(-1396.000000, -499.000000)",
    fill: "#0A6FB3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cards",
    transform: "translate(190.000000, 384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Chevron-/-Right-/-XLarge-/-Active-Copy",
    transform: "translate(1183.445693, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-lineart-/--functional-toggle-arrow-left",
    transform: "translate(29.700374, 24.000000) scale(-1, 1) translate(-29.700374, -24.000000) translate(22.846441, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4398877,47.9445 C12.1828652,47.9445 11.8835768,47.7765 11.7133708,47.439 L0.170205991,24.702 C-0.0011423241,24.309 -0.0011423241,23.8605 0.170205991,23.4675 L11.7133708,0.7305 C11.9703933,0.225 12.5255618,0.057 12.9105244,0.393 C13.2954869,0.729 13.423427,1.4595 13.1675469,1.965 L1.92367042,24.084 L13.1675469,46.203 C13.4245693,46.7085 13.3388952,47.4375 12.9105244,47.775 C12.7825843,47.8875 12.611236,47.943 12.4398877,47.943 L12.4398877,47.9445 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBb8CarouselArrowActive);
export default __webpack_public_path__ + "static/media/bb8-carousel-arrow-active.1ccb549bc0f8f5b48b02d25e22ed52f3.svg";
export { ForwardRef as ReactComponent };